module.exports = "<ul class=\"ot-indicator-list\">\n  <li ng-repeat=\"indicator in vm.indicatorList\">\n    <ot-indicator item=\"indicator\"></ot-indicator>\n  </li>\n</ul>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/indicatorList.html
 ** module id = 287
 ** module chunks = 1
 **/